import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { planSettingsPath } from "@/react/helpers/urlHelpers";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useTrialBanner } from "./useTrialBanner";

export const VariantB = () => {
  const { trialEndDateMonthAndDayFormatted, expiringInTimer } =
    useTrialBanner();
  return (
    <div>
      <div className="text-darkest flex items-center gap-1">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm weight="font-semibold" size="text-base">
          {t("trial_banner.variant_b.upgrade_to_prevent", {
            formatted_date: trialEndDateMonthAndDayFormatted,
          })}
        </Typography.BodySm>
        {expiringInTimer && (
          <Typography.BodySm weight="font-normal" size="text-base">
            {t("trial_banner.variant_b.expiring_in", {
              expiring_in_timer: expiringInTimer,
            })}
          </Typography.BodySm>
        )}
        <Link to={planSettingsPath()}>
          <Button className="ml-1 text-base font-semibold" variant="circle">
            {t("trial_banner.variant_b.cta")}
          </Button>
        </Link>
      </div>
    </div>
  );
};
